module.exports = __webpack_public_path__ + "static/media/a-3-b.0d5b7907.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-3-b.jpg
// module id = 1097
// module chunks = 33